<script setup>
import {ref, onMounted, computed, watch} from 'vue';
import axios from 'axios';
import PillBase from "../../pills/pillBase.vue";

const props = defineProps({
    deltaTasksMarkedAsSent: {
        type: Number,
        required: false,
        default: 0,
    }
})

const stats = ref({
    currentCampaign: null,
    remainingActions: 0,
    remainingEmails: 0,
    totalContacts: 0,
    streak: 0,
});

const fetchStats = async () => {
    try {
        const response = await axios.get(route('assistant.dailyStats'));
        stats.value = response.data;
    } catch (error) {
        console.error('Error fetching contracts:', error);
    }
};

const dailyActions = computed(() => {
    if (isNaN(stats.value.remainingEmails - props.deltaTasksMarkedAsSent)) {
        return null;
    }

    if (stats.value.remainingEmails - props.deltaTasksMarkedAsSent > 0) {
        return stats.value.remainingEmails - props.deltaTasksMarkedAsSent
    }

    return 0;
});

const newContacts = computed(() => {
    if (isNaN(stats.value.totalContacts + props.deltaTasksMarkedAsSent)) {
        return 0;
    }

    return stats.value.totalContacts + props.deltaTasksMarkedAsSent;
});

watch(newContacts, (oldValue, newValue) => {
    if (newValue !== oldValue) {
        fetchStats();
    }
}, {deep: true});

onMounted(fetchStats);


</script>

<template>
    <div>
        <div class="grid-cols-3 gap-2 md:grid">
            <card-basic>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <h2 class="text-md shrink-0">{{ _mft('leadHunter:widget.weeklyActions.title') }}</h2>
                        <div class="text-right">
                            <span class="text-lg font-bold">{{ 50 - stats.remainingActions }}</span>
                        </div>
                    </div>
                    <h6 v-if="stats.remainingActions > 0">{{ stats.remainingActions }} {{ _mft('leadHunter:widget.weeklyActions.actionsRemaining.byline') }}</h6>
                    <h6 v-else>{{ _mft('leadHunter:widget.weeklyActions.noActionsRemaining.byline') }}</h6>
                </template>
            </card-basic>
            <card-basic>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <h2 class="text-md shrink-0">{{ _mft('leadHunter:widget.newContacts.title') }}</h2>
                        <div class="text-right">
                            <span class="text-lg font-bold">{{ newContacts }}</span>
                        </div>
                    </div>
                    <h6>{{ _mft('leadHunter:widget.newContacts.byline') }}</h6>
                </template>
            </card-basic>
            <card-basic>
                <template v-slot:body>
                    <div class="flex items-end justify-between">
                        <h2 class="text-md shrink-0">{{ _mft('leadHunter:widget.streak.title') }}</h2>
                        <div class="text-right">
                            <span class="text-lg font-bold">{{ stats.streak }}</span>
                        </div>
                    </div>
                    <h6>{{ _mft('leadHunter:widget.streak.byline') }}</h6>
                </template>
            </card-basic>
        </div>
        <div
            v-if="stats.currentCampaign"
            class="flex flex-col items-center mb-2 text-center"
        >
            <span
                v-if="stats.currentCampaign.status === 'running'"
                class="text-xs text-gray-500"
            >{{ _mft('leadHunter:currentCampaign') }}</span>
            <div class="flex">
                <span class="font-bold">
                    {{ stats.currentCampaign.name }}
                </span>
                <span
                    v-if="stats.currentCampaign.status === 'finished'"
                    size="sm"
                    class="text-gray-400 ml-2 text-xs"
                >({{ _mft('leadHunter:campaign.status.finished') }})</span>
            </div>
            <span
                v-if="stats.currentCampaign.status === 'finished'"
                class="text-xs text-gray-500"
            >{{ _mft('leadHunter:campaignFinishedRunning.noLeadsLeft') }}</span>
        </div>
        <div class="flex justify-center mb-8">
            <a :href="route('lead-hunter.home')" class="mf-link">
                <button-secondary size="sm">{{ _mft('leadHunter:changeCampaign') }}</button-secondary>
            </a>
        </div>
    </div>
</template>
